import { render, staticRenderFns } from "./Device-series.vue?vue&type=template&id=327b8492&scoped=true&"
import script from "./Device-series.vue?vue&type=script&lang=js&"
export * from "./Device-series.vue?vue&type=script&lang=js&"
import style0 from "./Device-series.vue?vue&type=style&index=0&id=327b8492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b8492",
  null
  
)

export default component.exports